export const STEPS = {
	FIRST: 1,
	SECOND: 2,
	THIRD: 3,
	FOURTH: 4
} as const;

export const CONTENT_STATES = {
	CREATE_ACCOUNT: 'CREATE_ACCOUNT',
	VERIFICATION_CODE: 'VERIFICATION_CODE',
	CREATE_PASSWORD: 'CREATE_PASSWORD',
	PERSONAL_INFORMATION: 'PERSONAL_INFORMATION',
	EDUCATION_INFORMATION: 'EDUCATION_INFORMATION',
	WORK_INFORMATION: 'WORK_INFORMATION'
} as const;

type StepContentMap = Record<number, keyof typeof CONTENT_STATES>;

export const INITIAL_CONTENT_STATES: StepContentMap = {
	[STEPS.FIRST]: CONTENT_STATES.PERSONAL_INFORMATION,
	[STEPS.SECOND]: CONTENT_STATES.EDUCATION_INFORMATION,
	[STEPS.THIRD]: CONTENT_STATES.WORK_INFORMATION
};

export type StepNumber = (typeof STEPS)[keyof typeof STEPS];
